<script>
import Multiselect from 'vue-multiselect'
import { Helper, debounce } from '@/mixin/helper'
import { DELETE_ADDRESS, GET_ADDRESS, GET_DETAIL_ADDRESS } from '@/services/api/master/address'

export default {
  props: {
    status: String,
  },
  components: {
    Multiselect,
  },
  apollo: {
    geofences: {
      query: GET_ADDRESS,
      manual: true,
      fetchPolicy: 'no-cache',
      variables: {
        filter: {
          isCustomer: false,
          pagination: {
            page: 1,
            show: 10,
          },
        },
      },
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.geofences.geofences.pagination.total
          this.geofences = data.geofences.geofences
        }
      },
    },
  },
  mixins: [Helper],
  data() {
    return {
      geofences: [],
      filterSelected: [],
      selectAll: false,
      deleteAddress: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      listAddress: [
        {
          key: 'columnCheck',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'fenceName',
          label: 'Nama Lokasi',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'category',
          label: 'Kategori Alamat',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'address',
          label: 'Alamat Lengkap',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'province',
          label: this.$t('master.list.address.province'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'city',
          label: this.$t('master.list.address.city'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ],
      show: [
        { key: 'fenceName', label: 'Nama Lokasi' },
        { key: 'category', label: 'Kategori Alamat' },
        { key: 'address', label: 'Alamat Lengkap' },
        { key: 'province', label: 'Provinsi' },
        { key: 'city', label: 'Kota' },
      ],
      show_model: [],
    }
  },
  computed: {
    rows() {
      return this.totalRows
    },

    visibleAddress() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.listAddress.filter(function (item) {
          return item.key == 'columnCheck' || item.key == 'columnLock' || result.includes(item.key)
        })
      } else {
        return this.listAddress
      }
    },
  },

  created() {
    this.$store.commit('masterAddress/SET_STATUS', this.status)
  },

  methods: {
    searchData: debounce(function () {
      this.onFiltered()
    }, 500),

    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      if (this.filter.length > 0 && this.filter.length < 3) return
      this.currentPage = 1
      this.$apollo.queries.geofences.refetch({
        filter: {
          isCustomer: false,
          search: this.filter,
          pagination: {
            page: 1,
            show: this.perPage,
          },
        },
      })
    },

    changePerPage(perPage) {
      this.perPage = perPage
      if (this.filter == null) {
        this.$apollo.queries.geofences.refetch({
          filter: {
            isCustomer: false,
            pagination: {
              page: 1,
              show: this.perPage,
            },
          },
        })
      } else {
        this.$apollo.queries.geofences.refetch({
          filter: {
            isCustomer: false,
            search: this.filter,
            pagination: {
              page: 1,
              show: this.perPage,
            },
          },
        })
      }
    },

    changePage(page) {
      this.currentPage = page
      if (this.filter == null) {
        this.$apollo.queries.geofences.refetch({
          filter: {
            isCustomer: false,
            pagination: {
              page: this.currentPage,
              show: this.perPage,
            },
          },
        })
      } else {
        this.$apollo.queries.geofences.refetch({
          filter: {
            isCustomer: false,
            search: this.filter,
            pagination: {
              page: this.currentPage,
              show: this.perPage,
            },
          },
        })
      }
    },

    async toggleAll(event) {
      var checked = event.target.checked
      var address = await this.$apollo.query({
        query: GET_ADDRESS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            isCustomer: false,
            pagination: {
              page: 1,
              show: this.totalRows,
            },
          },
        },
      })
      this.filterSelected = []
      if (checked) {
        this.filterSelected = address.data.geofences.geofences.data.map((item) => item.geofenceId)
        this.removeDisabledItem(address.data.geofences.geofences.data)
      } else {
        this.filterSelected = []
      }
    },

    removeDisabledItem(data) {
      data.forEach((item) => {
        if (item.category == 'Main Branch' || item.category == 'Branch') {
          var index = this.filterSelected.indexOf(parseInt(item.geofenceId))
          if (index !== -1) {
            this.filterSelected.splice(index, 1)
          }
        }
      })
    },

    checkTable(event) {
      if (event.target.checked) {
        this.filterSelected.push(parseInt(event.target.value))
        if (this.filterSelected.length == this.totalRows) {
          this.selectAll = true
        }
      } else {
        this.selectAll = false
        var index = this.filterSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterSelected.splice(index, 1)
        }
      }
    },

    clearTable() {
      this.filterSelected = []
      this.selectAll = false
    },

    openModalDelete() {
      for (let i = 0; i < this.filterSelected.length; i++) {
        this.$apollo
          .query({
            query: GET_DETAIL_ADDRESS,
            variables: {
              filter: {
                geofenceId: parseInt(this.filterSelected[i]),
              },
            },
          })
          .then((res) => {
            var isSuccessful = res.data.geofence.isSuccessful
            if (isSuccessful) {
              this.deleteAddress.push(res.data.geofence.geofence)
            }
          })
      }
      this.$bvModal.show('modal-delete-company')
    },

    toDelete(bvModalEvent) {
      bvModalEvent.preventDefault()

      let promises = []
      for (let i = 0; i < this.filterSelected.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DELETE_ADDRESS,
            variables: {
              input: {
                geofenceId: this.filterSelected[i],
              },
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$apollo.queries.geofences.refetch()
        this.$toast.success(`Data berhasil dihapus`)
        this.clearTable()
        this.$bvModal.hide('modal-delete-company')
      })
    },

    resetModal() {
      this.deleteAddress = []
    },

    onRowClicked(item) {
      this.$router.push({
        name: 'Master Address Update',
        params: { id: item.geofenceId },
      })
    },
  },
}
</script>

<template>
  <!-- Company -->
  <b-tab active class="border-0" @click="$store.commit('masterAddress/SET_STATUS', status)">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('master.list.address.address') }}</span>
    </template>

    <div class="clearfix mb-3 pb-3 border-3 border-bottom">
      <div class="float-end">
        <b-button
          v-if="filterSelected.length"
          variant="outline-danger"
          class="mx-2"
          @click="openModalDelete"
        >
          <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
        </b-button>

        <b-button variant="primary" @click="$router.push({ name: 'Master Address Create' })">
          <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
        </b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
        <h6 v-if="filterSelected.length" class="mc-row-check">
          <span class="badge btn-success">{{ filterSelected.length }}</span>
          {{ $t('master.form.address.selectedRow') }}
          <a class="color-primary" @click="clearTable">{{ $t('master.form.address.clearAll') }}</a>
        </h6>
      </div>

      <div class="col-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
        <div class="mc-table-view">
          <p class="mc-label">{{ $t('global.shown') }}</p>
          <multiselect
            v-model="show_model"
            :options="show"
            :multiple="true"
            placeholder="Semua Kolom"
            track-by="label"
            label="label"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center mc-table-view__search">
              <i class="mc-fa fas fa-search"></i>
              <b-form-input
                v-model="filter"
                type="search"
                :placeholder="$t('global.search') + '...'"
                class="ms-2"
                @input="searchData"
              ></b-form-input>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-responsive my-3 border border-1">
      <b-table
        small
        show-empty
        :fields="visibleAddress"
        :items="geofences.data"
        class="datatables"
        responsive="lg"
        empty-table
        :empty-text="$t('global.emptyTable')"
        :empty-filtered-text="$t('global.emptyFilteredTable')"
        @filtered="onFiltered"
        :busy="$apollo.queries.geofences.loading"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        <template #head(columnCheck)>
          <div class="form-check">
            <input
              class="form-check-input me-1"
              type="checkbox"
              value="all"
              v-model="selectAll"
              @input="toggleAll"
            />
          </div>
        </template>
        <template #head(columnLock)>
          <p></p>
        </template>

        <template #cell(columnCheck)="data">
          <div
            class="form-check"
            v-if="data.item.category == 'Main Branch' || data.item.category == 'Branch'"
          >
            <input
              class="form-check-input me-1"
              type="checkbox"
              :value="data.item.geofenceId"
              v-model="filterSelected"
              :disabled="true"
              @input="checkTable"
            />
          </div>
          <div class="form-check" v-else>
            <input
              class="form-check-input me-1"
              type="checkbox"
              :value="data.item.geofenceId"
              v-model="filterSelected"
              @input="checkTable"
            />
          </div>
        </template>

        <!-- TODO: Change the conditional to hasRelation & default by McEasy -->
        <template #cell(columnLock)="data">
          <div v-if="data.index == 0">
            <i class="fa fa-lock"></i>
          </div>
        </template>

        <template #cell(fenceName)="data">
          <a href="javascript:void(0)" @click="onRowClicked(data.item)">
            <strong class="text-primary">
              {{ data.item.fenceName }}
            </strong>
          </a>
        </template>
      </b-table>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            {{ $t('global.show') }}
            <b-form-select
              class="form-select form-select-sm"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @input="changePerPage"
            >
            </b-form-select>
            {{ $t('master.form.address.entry').toLowerCase() }}
            <p>
              {{ $t('global.show').toLowerCase() }}&nbsp;<strong>{{
                totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0
              }}</strong
              >&nbsp;{{ $t('global.until').toLowerCase() }}&nbsp;<strong>{{
                Math.min(totalRows, currentPage * perPage)
              }}</strong
              >&nbsp;{{ $t('global.from').toLowerCase() }}&nbsp;<strong>{{ totalRows }}</strong
              >&nbsp;
              {{ $t('master.form.address.entry').toLowerCase() }}
            </p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows == null ? rows : totalRows"
              :per-page="perPage"
              @change="changePage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal for Delete Confirmation -->
    <b-modal
      class="mc-modal"
      id="modal-delete-company"
      title="Hapus"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('global.deleteValidation') }}</p>
        <b-list-group>
          <b-list-group-item v-for="address in deleteAddress" :key="address.geofenceId">{{
            address.fenceName
          }}</b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2">
              {{ $t('global.no') }}
            </b-button>
            <b-button @click="toDelete" variant="primary"> {{ $t('global.yes') }} </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </b-tab>
</template>
